import store from '../store'

/**
 * Checks all required parameters are passed.
 *
 * @param required
 * @param params
 * @returns {*}
 */
function hasRequiredKeys(required, params) {
    const matches = required.map((key) => params.includes(key))

    return matches.every((key) => key)
}

/**
 * Checks whether passed parameters match the current data in the store.
 *
 * @param query
 * @returns {boolean}
 */
function currentParametersMatch(query) {
    const current = store.getters['settings/get']

    return Object.entries(query)
        .map((param) => {
            const [key, value] = param

            return current[key] === value
        })
        .every((param) => param)
}

export default function (to, from, next) {
    const required = [
        'platform',
        'company_uuid',
        'cc',
        'lang',
        'api_key',
    ]

    const parameters = Object.keys(to.query) ?? []

    if (to.name === 'Error') {
        next()
    } else if (hasRequiredKeys(required, parameters)) { // If the required parameters are passed
        if (
            !store.getters['settings/hasRequiredParameters']
            || (store.getters['settings/hasRequiredParameters'] && !currentParametersMatch(to.query))
        ) {
            const { platform, company_uuid, cc, lang, api_key, msisdn, userId, access_token, uvid, redirect_url, period_id } = to.query
            const { device_type, device_identifier, device_name, device_version } = to.query

            if (typeof access_token !== 'undefined') {
                store.dispatch('user/restoreSession', {
                    access_token,
                });
            }

            store.dispatch('settings/set', {
                platform,
                company_uuid,
                cc,
                lang,
                api_key,
                msisdn,
                userId,
                access_token,
                uvid,
                redirect_url,
                period_id,
            })

            if (typeof device_type !== 'undefined' && typeof device_identifier !== 'undefined') {
                store.dispatch('device/set', {
                    device_type,
                    device_identifier,
                    device_name,
                    device_version,
                })
            }
        }

        next()
    } else if (store.getters['settings/hasRequiredParameters']) {
        next()
    } else {
        const cc = process.env.VUE_APP_DEFAULT_COUNTRY
        const lang = process.env.VUE_APP_DEFAULT_lANG
        const platform = process.env.VUE_APP_DEFAULT_PLATFORM
        const company_uuid = process.env.VUE_APP_COMPANY_UUID
        const api_key = process.env.VUE_APP_API_KEY

        store.dispatch('settings/set', {
            platform,
            company_uuid,
            cc,
            lang,
            api_key,
        })

        next();
    }
}
